import {Component} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import {filter, first, map, shareReplay, switchMap} from "rxjs/operators";
import {AuthenticationService} from "@app/core/authentication/authentication.service";
import {Credentials, CredentialsService} from "@app/core/authentication/credentials.service";
import {BackendService} from "@app/core/backendService/backend.service";
import {Router} from "@angular/router";
import {Observable, ReplaySubject, Subscription} from "rxjs";


@Component({
  selector: 'app-user-delete-dialog',
  templateUrl: './user-delete-dialog.component.html',
  styles: [``]
})
export class UserDeleteDialogComponent{
  constructor(
    public backendService: BackendService,
    public credentialsService: CredentialsService,
    private readonly router: Router,
    public authenticationService: AuthenticationService,
    public dialogRef: MatDialogRef<UserDeleteDialogComponent>,
  ) {}

  public isEnd$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1)
  public participantID$: Observable<number> = this.credentialsService.change$.pipe(
    map((credentials:Credentials)=>credentials?.participant_id),
    shareReplay(1)
  )

  public delete_user(){
    this.participantID$.pipe(
      filter((id:number)=>!!id),
      switchMap((id:number)=>this.backendService.delete_user(id)),
      switchMap(()=>this.authenticationService.logout()),
      first()
    )
    .subscribe(
      ()=>{
          this.isEnd$.next(true)
          this.router.navigate(['/'])
      },
      (err)=>console.log({err})
    )

  }

  public close(){ this.dialogRef.close() }
}
